import { useEffect } from 'react';
import { UnderDev } from '../../../../app/components';
import {
  useBreadcrumbsContext,
  useHeaderContext,
} from '../../../../app/context';
import { OperationsLoansContainer } from './styles';
import FileIcon from 'app/components/Icons/FileIcon';
import { useTheme } from '@mui/material';

const OperationsLoans = () => {
  const theme = useTheme();
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { setTitle, resetTitle } = useHeaderContext();

  useEffect(() => {
    setItems(
      [
        { to: '/operations/main', label: 'Operações' },
        { to: '/operations/main/loans', label: 'Empréstimos' },
      ],
      <FileIcon color={theme.palette.text.secondary} />,
    );

    return resetBreadcrumbs;
  }, []);

  useEffect(() => {
    setTitle('Empréstimos');
    return resetTitle;
  }, []);

  return (
    <OperationsLoansContainer>
      <UnderDev />
    </OperationsLoansContainer>
  );
};

export default OperationsLoans;
